import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close-grey.svg'


const _withScopeId = n => (_pushScopeId("data-v-6eeb9ee7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-p-10 modal-add-domain" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`tw-text-[25px] tw-text-[#211F58] tw-font-[Poppins] tw-font-[600] tw-mb-[15px] tw-leading-[145%]`)
}
const _hoisted_3 = { class: "tw-text-[15px] tw-text-[#231F20] tw-font-[400] tw-leading-[145%] tw-mb-[25px]" }
const _hoisted_4 = {
  key: 0,
  class: "tw-text-[#F7553C] tw-text-[11px] tw-leading-none tw-my-[10px]"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "tw-flex tw-justify-end tw-mt-[25px]" }

import store from "../../store";
import utilities, {
  IsSpecialCharDomainValid,
  getComponentUiText,
} from "../../utils/utilities";
import { Ref, computed, reactive, ref, watch } from "vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";

import Modal from "../common/modal.vue";
import ModalHeader from "../common/modalHeader.vue";
import InputField from "../common/inputField1.vue";
import { postAddOrgDomain } from "@/services/org";
import { tlDomain } from "@/utils/validationRules";
import { helpers, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

import commonServices from "@/services/common/commonServices";
import BaseForm from "../common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";

const DEFAULT_MAX_WIDTH_MODAL = 65;
const cssFieldEmail =
  "tw-gap-2.5 tw-border tw-text-[#231F20] tw-text-[15px] tw-leading-none tw-pl-[25px] tw-pr-[45px] tw-py-[20px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#F7F7F8]";
const CUSTOM_CLASS_INPUT_INVALID = "input-invalid-style-1";

export default /*#__PURE__*/_defineComponent({
  __name: 'addDomainModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
},
  emits: ["update:show", "add:domain:success"],
  setup(__props, { emit }) {

const props = __props;

const customClassInputEmail = ref(cssFieldEmail);
const initialForm = { domain: "" };
const form = reactive(initialForm);
const focus = ref(false);
const rules = {
  domain: {
    required: helpers.withMessage(
      () => getUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-base-input-email-invalid-special-domain-characters-1",
        ),
      IsSpecialCharDomainValid,
    ),
    domain: helpers.withMessage(
      () =>
        getUiText(
          "app-settings-domain-add-modal-domain-invalid-error-message-1",
        ),
      tlDomain,
    ),
  },
};



const v$ = useVuelidate(rules, form);
const loading = ref(false);
const showRef: Ref<boolean> = ref(props.show);
const isDisableAddDomain: Ref<boolean> = ref(true);
const errorAddDomain: Ref<string> = ref("");
const commonService = new commonServices();
let isAddingDomain = false;
watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (props.show === true) {
      form.domain = "";
      isDisableAddDomain.value = true;
      customClassInputEmail.value = cssFieldEmail;
    }
  },
);

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const onFocus = (isFocus) => {
  focus.value = isFocus;
  handleUpdateCssInput();
};

const getErrorMessage = (errors: any) => {
  const idxMessage = errors.findIndex((error) => error.$validator !== "domain");
  return errors[idxMessage].$message;
};

const handleUpdateCssInput = () => {
  if (
    v$.value.domain.$errors.length === 0 ||
    (focus.value &&
      v$.value.domain.$errors.length === 1 &&
      v$.value.domain.$errors[0].$validator === "domain")
  ) {
    isDisableAddDomain.value = false;
    customClassInputEmail.value = cssFieldEmail;
  } else {
    isDisableAddDomain.value = true;
    customClassInputEmail.value = `${cssFieldEmail} ${CUSTOM_CLASS_INPUT_INVALID}`;
  }
};

const updateValueInputFiled = (value) => {
  if (value.trim() === "") v$.value.domain.$reset();
  else {
    v$.value.domain.$touch();
    v$.value.domain.$model = value;
  }

  handleUpdateCssInput();
};

const addDomain = async () => {
  if (isAddingDomain) return;
  isAddingDomain = true;
  await v$.value.$validate();
  if (v$.value.$invalid) {
    handleUpdateCssInput();
    isAddingDomain = false;
    return;
  }

  try {
    commonService.setCursorLoading();
    loading.value = true;
    const res = await postAddOrgDomain(form.domain);
    handleCloseModal();
    if (res && res.data && res.data.data)
      emit("add:domain:success", {
        id: res.data.data.domainId,
        ...res.data.data,
      });
  } catch (error: any) {
    if (error && error.data && error.data.error) {
      errorAddDomain.value = error.data.error.message || "";
      if (error && error.data) {
        showErrorAPI(error, Org.domain);
      }

      isDisableAddDomain.value = true;
      customClassInputEmail.value = `${cssFieldEmail} ${CUSTOM_CLASS_INPUT_INVALID}`;
    }
  } finally {
    loading.value = false;
    isAddingDomain = false;
    commonService.setCursorDefault();
  }
};

const handleCloseModal = () => {
  loading.value = false;
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

const clearData = () => {
  form.domain = "";
  isDisableAddDomain.value = true;
  customClassInputEmail.value = cssFieldEmail;
  v$.value.domain.$model = "";
  v$.value.domain.$reset();
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] add-domain-modal",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    visible: showRef.value,
    value: form,
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        title: getUiText('app-settings-domain-add-modal-title-1'),
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getComponentUiText)("app-settings-domain-add-new-modal-title-1")), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-settings-domain-add-modal-description-1")), 1),
        _createVNode(BaseForm, {
          show: showRef.value,
          "enter-event": true,
          "onOn:submit": addDomain
        }, {
          default: _withCtx(() => [
            _createVNode(InputField, {
              value: form.domain,
              "onUpdate:value": [
                _cache[0] || (_cache[0] = ($event: any) => ((form.domain) = $event)),
                updateValueInputFiled
              ],
              type: "input",
              "data-cy": "add-domain-modal-input",
              placeholder: 
            getUiText('app-settings-domain-add-modal-input-prompt-1')
          ,
              "class-style": customClassInputEmail.value,
              class: "autoFocus",
              "onOn:blur": _cache[1] || (_cache[1] = ($event: any) => (onFocus(false))),
              "onOn:focus": _cache[2] || (_cache[2] = ($event: any) => (onFocus(true)))
            }, {
              icon: _withCtx(() => [
                (form.domain !== '')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "tw-w-3 tw-h-3 icon-input-clear tw-cursor-pointer",
                      src: _imports_0,
                      alt: "close",
                      onClick: clearData
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value", "placeholder", "class-style"]),
            (
            _unref(v$).domain.$errors.length > 0 &&
            (!focus.value ||
              (focus.value &&
                _unref(v$).domain.$errors.findIndex(
                  (error) => error.$validator !== 'domain',
                ) >= 0))
          )
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  (focus.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(getErrorMessage(_unref(v$).domain.$errors)), 1))
                    : _createCommentVNode("", true),
                  (!focus.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(v$).domain.$errors?.[0]?.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_b_button, {
                pill: "",
                variant: "primary",
                "data-cy": "add-domain-modal-button",
                class: _normalizeClass(`button-setting-add-domain tw-bg-[#387DFF] tw-py-[11px] ${
              loading.value ? 'tw-relative' : ''
            } tw-text-[15px] tw-font-medium tw-leading-none`),
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(`${loading.value ? 'tw-text-transparent' : ''}`)
                  }, _toDisplayString(getUiText("app-settings-domain-add-modal-add-button-1")), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass(`tw-w-[39px] tw-h-[39px] tw-flex tw-items-center tw-justify-center tw-absolute tw-top-[-1] ${
                loading.value ? '' : 'tw-hidden'
              }`)
                  }, [
                    _createVNode(_unref(LottieAnimation), {
                      ref: "anim",
                      "animation-data": _unref(ProgressAnimation),
                      "auto-play": true,
                      loop: true
                    }, null, 8, ["animation-data"])
                  ], 2)
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "value"]))
}
}

})